[
  {
    "id": "165594923586945025",
    "tag": "Panwells",
    "position": "Game Creator"
  },
  {
    "id": "1053817029502709820",
    "tag": "SoCalifornian",
    "position": "Scripter"
  },
  {
    "id": "289372404541554689",
    "tag": "SkilledOn",
    "position": "Community Manager/Developer"
  },
  {
    "id": "396347223736057866",
    "tag": "Regalijan",
    "position": "Head of Forum Moderation"
  },
  {
    "id": "165047934113677312",
    "tag": "Virtruvious",
    "position": "Director of Discord Moderation"
  },
  {
    "id": "135418199083581440",
    "tag": "Dan",
    "position": "Head of Discord Moderation"
  },
  {
    "id": "151098768807165952",
    "tag": "Redious",
    "position": "Director of Wall Moderation"
  },
  {
    "id": "430533277384704010",
    "tag": "Mason",
    "position": "Head of Wall Moderation"
  },
  {
    "id": "392947931336146945",
    "tag": "3_Row",
    "position": "Head of Wall Moderation"
  },
  {
    "id": "884831305831948338",
    "tag": "Mustang",
    "position": "Events Coordinator"
  }
]
